export enum ActionTypes {
    changeTypeGame
}